var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChatSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.08231 12L3.14956 17.0088C2.4384 18.8518 4.3939 20.605 6.26112 19.7985L19.6391 14.0202C21.4536 13.2365 21.4536 10.7635 19.6391 9.97976L6.26113 4.20154C4.3939 3.39505 2.4384 5.14823 3.14956 6.99121L5.08231 12ZM5.08231 12H12.7759",
    stroke: "#A7A7A7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatSend);
export default __webpack_public_path__ + "static/media/chat-send.f6e9f623ec57104f253b0f50c49e27f4.svg";
export { ForwardRef as ReactComponent };